const mutations = {
  SET_IOS(state, { ios }) {
    state.ios = ios;
    state.showDownloadBanner = ios.tutu.needResign;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js